import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import { navigate } from "vike/client/router"
import Panel from "aldoo-ra/Panel"

const MergeInfo = ({ mergeInfo, onNavigateToTicket }) => {
  if (!mergeInfo) return null

  // Function to handle ticket navigation
  const handleTicketNavigation = (ticketId) => {
    if (onNavigateToTicket) {
      // Use callback if provided by parent
      onNavigateToTicket(ticketId)
    } else {
      // Otherwise use Vike navigation
      navigate(`/admin/customer-support/tickets/${ticketId}`)
    }
  }

  return (
      <Panel
                    variant="admin_bordered"
                    title="Merge Information"
                    defaultOpen={false}
                    scrollable={true}
                    className="min-h-0"
                    bodyClassName="overflow-y-auto"
                  >

      {mergeInfo.isPrimary && (
        <>
          <Typography
            variant="admin_body"
            className="mb-2"
          >
            <span className="font-bold">
            Type:</span> Primary Ticket
          </Typography>

          {mergeInfo.secondaryTickets &&
            mergeInfo.secondaryTickets.length > 0 && (
              <div className="mb-2">
                <Typography
                  variant="admin_body"
                  className="font-bold mb-1"
                >
                  Merged Tickets:
                </Typography>

                <div className="pl-4">
                  {mergeInfo.secondaryTicketDetails
                    ? mergeInfo.secondaryTicketDetails.map((ticket) => (
                        <Typography
                          key={ticket.ticketID}
                          variant="admin_body"
                          className="mb-1"
                        >
                          •{" "}
                          <span
                            className="text-admin_primary hover:underline cursor-pointer"
                            onClick={() =>
                              handleTicketNavigation(ticket.ticketID)
                            }
                          >
                            #{ticket.ticketID}
                          </span>{" "}
                          - {ticket.summary}
                        </Typography>
                      ))
                    : mergeInfo.secondaryTickets.map((ticketId) => (
                        <Typography
                          key={ticketId}
                          variant="admin_body"
                          className="mb-1"
                        >
                          •{" "}
                          <span
                            className="text-admin_primary hover:underline cursor-pointer"
                            onClick={() => handleTicketNavigation(ticketId)}
                          >
                            #{ticketId}
                          </span>
                        </Typography>
                      ))}
                </div>
              </div>
            )}
        </>
      )}

      {mergeInfo.isSecondary && (
        <>
          <Typography
            variant="admin_body"
            className="mb-2"
          >
            <span className="font-bold">Type:</span>{" "}
            Secondary Ticket (Merged)
          </Typography>

          <div className="mb-3">
            <Typography
              variant="admin_body"
              className="mb-1"
            >
              <span className="font-bold">Merged into:</span>{" "}

              <span
                className="text-admin_primary hover:underline cursor-pointer"
                onClick={() => handleTicketNavigation(mergeInfo.primaryTicket)}
              >
                #{mergeInfo.primaryTicket}
              </span>

              {mergeInfo.primaryTicketDetails && (
                <span> - {mergeInfo.primaryTicketDetails.summary}</span>
              )}
            </Typography>

            <Button
              variant="admin_secondary"
              className="mt-2"
              onClick={() => handleTicketNavigation(mergeInfo.primaryTicket)}
            >
              View Primary Ticket
            </Button>
          </div>
        </>
      )}

      {mergeInfo.mergeDate && (
        <Typography
          variant="admin_body"
          className="mb-2"
        >
          <span className="font-bold">Merged on:</span>{" "}
          {new Date(mergeInfo.mergeDate).toLocaleString()}
        </Typography>
      )}

      {mergeInfo.mergedBy && (
        <Typography variant="admin_body">
          <span className="font-bold">Merged by:</span>{" "}
          {mergeInfo.mergedBy.name || mergeInfo.mergedBy.email}
        </Typography>
        )}
      </Panel>
  )
}

export default MergeInfo
